import { eraForDateTime as M, monthForDateTime as F, weekdayForDateTime as S, meridiemForDateTime as g } from "./contact-channels146.js";
import { DATETIME_HUGE_WITH_SECONDS as _, DATETIME_FULL_WITH_SECONDS as p, DATETIME_MED_WITH_SECONDS as L, DATETIME_SHORT_WITH_SECONDS as k, DATETIME_HUGE as w, DATETIME_FULL as I, DATETIME_MED as O, DATETIME_SHORT as Z, TIME_24_WITH_LONG_OFFSET as d, TIME_24_WITH_SHORT_OFFSET as H, TIME_24_WITH_SECONDS as W, TIME_24_SIMPLE as N, TIME_WITH_LONG_OFFSET as v, TIME_WITH_SHORT_OFFSET as A, TIME_WITH_SECONDS as G, TIME_SIMPLE as C, DATE_HUGE as U, DATE_FULL as b, DATE_MED as R, DATE_SHORT as q } from "./contact-channels134.js";
import { padStart as z } from "./contact-channels128.js";
function E(D, e) {
  let r = "";
  for (const t of D)
    t.literal ? r += t.val : r += e(t.val);
  return r;
}
const x = {
  D: q,
  DD: R,
  DDD: b,
  DDDD: U,
  t: C,
  tt: G,
  ttt: A,
  tttt: v,
  T: N,
  TT: W,
  TTT: H,
  TTTT: d,
  f: Z,
  ff: O,
  fff: I,
  ffff: w,
  F: k,
  FF: L,
  FFF: p,
  FFFF: _
};
class T {
  static create(e, r = {}) {
    return new T(e, r);
  }
  static parseFormat(e) {
    let r = null, t = "", n = !1;
    const a = [];
    for (let o = 0; o < e.length; o++) {
      const u = e.charAt(o);
      u === "'" ? ((t.length > 0 || n) && a.push({
        literal: n || /^\s+$/.test(t),
        val: t === "" ? "'" : t
      }), r = null, t = "", n = !n) : n || u === r ? t += u : (t.length > 0 && a.push({ literal: /^\s+$/.test(t), val: t }), t = u, r = u);
    }
    return t.length > 0 && a.push({ literal: n || /^\s+$/.test(t), val: t }), a;
  }
  static macroTokenToFormatOpts(e) {
    return x[e];
  }
  constructor(e, r) {
    this.opts = r, this.loc = e, this.systemLoc = null;
  }
  formatWithSystemDefault(e, r) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(e, { ...this.opts, ...r }).format();
  }
  dtFormatter(e, r = {}) {
    return this.loc.dtFormatter(e, { ...this.opts, ...r });
  }
  formatDateTime(e, r) {
    return this.dtFormatter(e, r).format();
  }
  formatDateTimeParts(e, r) {
    return this.dtFormatter(e, r).formatToParts();
  }
  formatInterval(e, r) {
    return this.dtFormatter(e.start, r).dtf.formatRange(e.start.toJSDate(), e.end.toJSDate());
  }
  resolvedOptions(e, r) {
    return this.dtFormatter(e, r).resolvedOptions();
  }
  num(e, r = 0, t = void 0) {
    if (this.opts.forceSimple)
      return z(e, r);
    const n = { ...this.opts };
    return r > 0 && (n.padTo = r), t && (n.signDisplay = t), this.loc.numberFormatter(n).format(e);
  }
  formatDateTimeFromString(e, r) {
    const t = this.loc.listingMode() === "en", n = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", a = (s, m) => this.loc.extract(e, s, m), o = (s) => e.isOffsetFixed && e.offset === 0 && s.allowZ ? "Z" : e.isValid ? e.zone.formatOffset(e.ts, s.format) : "", u = () => t ? g(e) : a({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), i = (s, m) => t ? F(e, s) : a(m ? { month: s } : { month: s, day: "numeric" }, "month"), h = (s, m) => t ? S(e, s) : a(
      m ? { weekday: s } : { weekday: s, month: "long", day: "numeric" },
      "weekday"
    ), c = (s) => {
      const m = T.macroTokenToFormatOpts(s);
      return m ? this.formatWithSystemDefault(e, m) : s;
    }, l = (s) => t ? M(e, s) : a({ era: s }, "era"), f = (s) => {
      switch (s) {
        // ms
        case "S":
          return this.num(e.millisecond);
        case "u":
        // falls through
        case "SSS":
          return this.num(e.millisecond, 3);
        // seconds
        case "s":
          return this.num(e.second);
        case "ss":
          return this.num(e.second, 2);
        // fractional seconds
        case "uu":
          return this.num(Math.floor(e.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(e.millisecond / 100));
        // minutes
        case "m":
          return this.num(e.minute);
        case "mm":
          return this.num(e.minute, 2);
        // hours
        case "h":
          return this.num(e.hour % 12 === 0 ? 12 : e.hour % 12);
        case "hh":
          return this.num(e.hour % 12 === 0 ? 12 : e.hour % 12, 2);
        case "H":
          return this.num(e.hour);
        case "HH":
          return this.num(e.hour, 2);
        // offset
        case "Z":
          return o({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return o({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return o({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return e.zone.offsetName(e.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return e.zone.offsetName(e.ts, { format: "long", locale: this.loc.locale });
        // zone
        case "z":
          return e.zoneName;
        // meridiems
        case "a":
          return u();
        // dates
        case "d":
          return n ? a({ day: "numeric" }, "day") : this.num(e.day);
        case "dd":
          return n ? a({ day: "2-digit" }, "day") : this.num(e.day, 2);
        // weekdays - standalone
        case "c":
          return this.num(e.weekday);
        case "ccc":
          return h("short", !0);
        case "cccc":
          return h("long", !0);
        case "ccccc":
          return h("narrow", !0);
        // weekdays - format
        case "E":
          return this.num(e.weekday);
        case "EEE":
          return h("short", !1);
        case "EEEE":
          return h("long", !1);
        case "EEEEE":
          return h("narrow", !1);
        // months - standalone
        case "L":
          return n ? a({ month: "numeric", day: "numeric" }, "month") : this.num(e.month);
        case "LL":
          return n ? a({ month: "2-digit", day: "numeric" }, "month") : this.num(e.month, 2);
        case "LLL":
          return i("short", !0);
        case "LLLL":
          return i("long", !0);
        case "LLLLL":
          return i("narrow", !0);
        // months - format
        case "M":
          return n ? a({ month: "numeric" }, "month") : this.num(e.month);
        case "MM":
          return n ? a({ month: "2-digit" }, "month") : this.num(e.month, 2);
        case "MMM":
          return i("short", !1);
        case "MMMM":
          return i("long", !1);
        case "MMMMM":
          return i("narrow", !1);
        // years
        case "y":
          return n ? a({ year: "numeric" }, "year") : this.num(e.year);
        case "yy":
          return n ? a({ year: "2-digit" }, "year") : this.num(e.year.toString().slice(-2), 2);
        case "yyyy":
          return n ? a({ year: "numeric" }, "year") : this.num(e.year, 4);
        case "yyyyyy":
          return n ? a({ year: "numeric" }, "year") : this.num(e.year, 6);
        // eras
        case "G":
          return l("short");
        case "GG":
          return l("long");
        case "GGGGG":
          return l("narrow");
        case "kk":
          return this.num(e.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(e.weekYear, 4);
        case "W":
          return this.num(e.weekNumber);
        case "WW":
          return this.num(e.weekNumber, 2);
        case "n":
          return this.num(e.localWeekNumber);
        case "nn":
          return this.num(e.localWeekNumber, 2);
        case "ii":
          return this.num(e.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(e.localWeekYear, 4);
        case "o":
          return this.num(e.ordinal);
        case "ooo":
          return this.num(e.ordinal, 3);
        case "q":
          return this.num(e.quarter);
        case "qq":
          return this.num(e.quarter, 2);
        case "X":
          return this.num(Math.floor(e.ts / 1e3));
        case "x":
          return this.num(e.ts);
        default:
          return c(s);
      }
    };
    return E(T.parseFormat(r), f);
  }
  formatDurationFromString(e, r) {
    const t = this.opts.signMode === "negativeLargestOnly" ? -1 : 1, n = (c) => {
      switch (c[0]) {
        case "S":
          return "milliseconds";
        case "s":
          return "seconds";
        case "m":
          return "minutes";
        case "h":
          return "hours";
        case "d":
          return "days";
        case "w":
          return "weeks";
        case "M":
          return "months";
        case "y":
          return "years";
        default:
          return null;
      }
    }, a = (c, l) => (f) => {
      const s = n(f);
      if (s) {
        const m = l.isNegativeDuration && s !== l.largestUnit ? t : 1;
        let y;
        return this.opts.signMode === "negativeLargestOnly" && s !== l.largestUnit ? y = "never" : this.opts.signMode === "all" ? y = "always" : y = "auto", this.num(c.get(s) * m, f.length, y);
      } else
        return f;
    }, o = T.parseFormat(r), u = o.reduce(
      (c, { literal: l, val: f }) => l ? c : c.concat(f),
      []
    ), i = e.shiftTo(...u.map(n).filter((c) => c)), h = {
      isNegativeDuration: i < 0,
      // this relies on "collapsed" being based on "shiftTo", which builds up the object
      // in order
      largestUnit: Object.keys(i.values)[0]
    };
    return E(o, a(i, h));
  }
}
export {
  T as default
};
//# sourceMappingURL=contact-channels125.js.map
